<template>
    <div class="video-items-container" v-if="videoItems != null">
        <div class="video-items">
            <div class="video-item" v-for="item in videoItems" :class="{animate : videoCardAnimate}">
                <!-- :to="'/news/' + cytTolat(item.title)" -->
                <a href="#" class="link-open-modal" @click.prevent="openVideoModal(item.date, item.title, item.video_link)">
                    <div class="video-item-img">
                        <img :src="item.video_preview" alt="">
                        <div class="icon-play-con">
                            <svgIcon name="play" class="icon-play"/>
                        </div>
                    </div>
                    <div class="video-date">
                        <span>{{correctDate(item.date)}}</span>
                    </div>
                    <div class="video-title">
                        <h2>{{item.title}}</h2>
                    </div>
                </a>
            </div>
        </div>
        <modal name="video-modal" 
            @before-close="beforeVideoModalClose" 
            @closed="videoModalClosed" 
            :transition="transitionName" 
            :width="modalWidth" 
            :height="modalHeight" 
            :scrollable="modalScrollable"  
            class="video-item-modal"               
            id="video-modal">
            <div class="modal-content" v-if="modalData.date != null && modalData.title != null && modalData.link != null">
                <div class="video-date">
                    <span>{{correctDate(modalData.date)}}</span>
                </div>
                <div class="video-title">
                    <h2>{{modalData.title}}</h2>
                </div>
                <div class="video-player">
                    <iframe :src="modalData.link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                </div>
                <a href="#" class="close-link" @click.prevent="closeVideoModal">
                    <svgIcon name="close" class="icon-close"/>
                </a>
            </div>
        </modal>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'video-item',
        components: {
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                modalData: {
                    date: null,
                    title: null,
                    link: null
                },
                transitionName: 'pop-out',
                lang: window.GlobalLang,
            }
        },
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8,10));
                var month = date.slice(5,7);
                var year = date.slice(0,4);
                var monthFont;
                var total;
                if (this.lang == 'kz/') {
                    if (month == '01') {
                        monthFont = 'Қаңтар'
                    } else if (month == '02') {
                        monthFont = 'Ақпан'
                    } else if (month == '03') {
                        monthFont = 'Наурыз'
                    } else if (month == '04') {
                        monthFont = 'Сәуiр'
                    } else if (month == '05') {
                        monthFont = 'Мамыр'
                    } else if (month == '06') {
                        monthFont = 'Маусым'
                    } else if (month == '07') {
                        monthFont = 'Шiлде'
                    } else if (month == '08') {
                        monthFont = 'Тамыз'
                    } else if (month == '09') {
                        monthFont = 'Қыркүйек'
                    } else if (month == '10') {
                        monthFont = 'Қазан'
                    } else if (month == '11') {
                        monthFont = 'Қараша'
                    } else if (month == '12') {
                        monthFont = 'Желтоқсан'
                    }
                } else if (this.lang == 'en/') {
                    if (month == '01') {
                        monthFont = 'January'
                    } else if (month == '02') {
                        monthFont = 'February'
                    } else if (month == '03') {
                        monthFont = 'March'
                    } else if (month == '04') {
                        monthFont = 'April'
                    } else if (month == '05') {
                        monthFont = 'May'
                    } else if (month == '06') {
                        monthFont = 'June'
                    } else if (month == '07') {
                        monthFont = 'July'
                    } else if (month == '08') {
                        monthFont = 'August'
                    } else if (month == '09') {
                        monthFont = 'September'
                    } else if (month == '10') {
                        monthFont = 'October'
                    } else if (month == '11') {
                        monthFont = 'November'
                    } else if (month == '12') {
                        monthFont = 'December'
                    }
                } else {
                    if (month == '01') {
                        monthFont = 'Января'
                    } else if (month == '02') {
                        monthFont = 'Февраля'
                    } else if (month == '03') {
                        monthFont = 'Марта'
                    } else if (month == '04') {
                        monthFont = 'Апреля'
                    } else if (month == '05') {
                        monthFont = 'Мая'
                    } else if (month == '06') {
                        monthFont = 'Июня'
                    } else if (month == '07') {
                        monthFont = 'Июля'
                    } else if (month == '08') {
                        monthFont = 'Августа'
                    } else if (month == '09') {
                        monthFont = 'Сентября'
                    } else if (month == '10') {
                        monthFont = 'Октября'
                    } else if (month == '11') {
                        monthFont = 'Ноября'
                    } else if (month == '12') {
                        monthFont = 'Декабря'
                    }
                }
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
            setFilterNewsLength() {
                if (this.routerName != 'home') {
                    this.$store.commit('filterVideoItems', this.videoItemsDefault);
                }
            },
            startLoader() {
                if (this.routerName == 'home') {
                    this.$parent.$parent.$parent.$refs.topProgress.start();
                } else  {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            },
            openVideoModal(date, title, link) {
                this.modalData.date = date;
                this.modalData.title = title;
                this.modalData.link = link;
                this.$modal.show('video-modal');
                document.getElementsByTagName('body')[0].classList.add('video_open');
            },
            closeVideoModal() {
                this.$modal.hide('video-modal');
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            beforeVideoModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            videoModalClosed() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            }
        },
        computed: mapGetters({
            videoItems: 'loadVideoItems',
            videoCardAnimate: 'loadVideoCardAnimateStatus',
            videoItemsDefault: 'loadVideoItemsDefault',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.setFilterNewsLength();
            // this.$store.watch(
            //     (state) => state.videoItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.setFilterNewsLength();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/video-page/video-items.scss';
    @import '@/styles/components/video-page/respond/video-items-respond.scss';
    // @import '@/styles/respond/video/video-item-respond.scss';
    // @import '@/styles/respond/news/news-item-respond.scss';
</style>